import { isNullOrWhiteSpace } from "../utils/string";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TranslationValue = string | number | boolean | null | TranslationDictionary | any[];

export type TranslationDictionary = {
  [key: string]: TranslationValue;
};

export type ValueDictionary = Record<string, string | number | null | undefined>;

export type TranslationFn = (t: string, values?: ValueDictionary) => string;

const isObject = (o: unknown): o is Record<string, unknown> =>
  o != null && typeof o === "object" && !Array.isArray(o) && o.constructor === Object;

const mergeDictionaries = (target: TranslationDictionary, source: TranslationDictionary): TranslationDictionary => {
  const result: TranslationDictionary = Array.isArray(target) || Array.isArray(source) ? source : { ...target };
  Object.entries(source).forEach(([key, value]) => {
    const current = result[key];
    if (isObject(current) && isObject(value)) {
      result[key] = mergeDictionaries(current, value);
    } else {
      result[key] = value;
    }
  });
  return result;
};

const stringReplacer = (template: string, data: ValueDictionary) => {
  const pattern = /{{\s*(\w+?)\s*}}/g; // {{property}}
  return template.replace(pattern, (_, token: string) => data[token]?.toString() ?? "");
};

let dictionary: TranslationDictionary;

export function init(messages: TranslationDictionary) {
  dictionary = mergeDictionaries({}, messages);
}

export function extend(messages: TranslationDictionary) {
  const base = isObject(dictionary) ? dictionary : {};
  dictionary = mergeDictionaries(base, messages);
}

export function translate(translation: string, values?: ValueDictionary) {
  if (typeof translation !== "string" || !isObject(dictionary)) {
    return "";
  }

  values = isObject(values) ? values : {};

  let fragments = translation.split(".");
  if (fragments.length === 0) {
    fragments = [translation];
  }

  let localizationText: TranslationValue = dictionary;
  while (fragments.length > 0) {
    const key = fragments[0];
    if (isObject(localizationText) && !Array.isArray(localizationText) && key in localizationText) {
      localizationText = localizationText[key];
    }
    fragments.shift();
  }

  return typeof localizationText === "string" && !isNullOrWhiteSpace(localizationText)
    ? stringReplacer(localizationText, values)
    : translation;
}

export function isValidLanguage(language?: string): boolean {
  if (!language) {
    return false;
  }

  const languageLowerCase = language.toLowerCase();
  switch (languageLowerCase) {
    case "nb":
    case "en":
      return true;
  }
  return false;
}

export function resolveSupportedLanguage(language?: string): "nb" | "en" {
  switch (language?.toLowerCase()) {
    case "nb":
    case "no":
    case "nn":
      return "nb";
    default:
      return "en";
  }
}
